<template>
<div class="irr-mask-time-line-wrap pt25">
  <div
    v-if="times().length === 0"
    class="time-line-tip">
      所选课次时间会展示在这
  </div>
  <div class="time-line-list-irr">
      <ul class="time-line">
          <li v-for="cell in times()" class="item" :key="cell.date + cell.groupId + cell.time">
              <a href="javascript:void(0);" class="time-line-txt">
                  {{cell.chinaDate}}
                  <span class="day">周{{cell.day}}</span>
                  <span class="border-spe"></span>
                  {{cell.time}}
                  <i class="icon-close" @click="onDel(cell)"></i>
              </a>
          </li>
      </ul>
  </div>
</div>
</template>
<style lang="less" src="./IrrSelectTimes.less">

</style>
<script>
import _ from 'lodash'
import { mapState } from 'vuex';
export default {
  name: 'IrrSelectTimes',
  computed: mapState({
    selectedTimes: state => state.newsign.irrSelectedTimeInfo
  }),
  data(){
    return {
       weeks: ['日', '一', '二', '三', '四', '五', '六']
    }
  },
  methods: {
    times(){
      var list = [];
      var dateKeys = _.keys(this.selectedTimes);
      dateKeys.forEach(key => {
        var item = this.selectedTimes[key];
        var dateInfo = key.split('-');
        var date = new Date(key.replace(/-/g, '/'));
        item.forEach(itemTime => {
          list.push(_.extend({
            date: key,
            chinaDate: `${dateInfo[1]}月${dateInfo[2]}日`,
            day: this.weeks[date.getDay()]
          }, itemTime));
        });
      })
      return list;
    },
    onDel(cell){
      var timeMap = JSON.parse(JSON.stringify(this.selectedTimes));
      if (timeMap[cell.date].length == 1){
        delete timeMap[cell.date];
      } else {
        var idx = _.findIndex(timeMap[cell.date], (item) => {
          return item.time === cell.time
        });
        timeMap[cell.date].splice(idx, 1);
      }
      this.$store.commit('updateIrrSelectedTimeInfo', timeMap);
      this.$emit('onDel', cell);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/courseCenter/newsign/IrrSelectTimes.vue